import { Box, Typography } from '@mui/material';
import { AnalyticsSkuViewed } from '@repo/segment/Analytics/AnalyticsSkuViewed';
import { EntityTypeEnum, MarketplaceStatusEnum } from '@repo/supergraph-schemas/marketplace/enums';
import { getSmbMarketplaceEntity } from '../query';
import { CtaComponent } from './CtaComponent';

const SECTION_NAME = 'illustration_card_list';

export const MarketplaceEntityCTA: React.FC<{
  marketplaceEntityId: string;
  text?: string;
}> = async ({ marketplaceEntityId, text }) => {
  const marketplaceEntity = await getSmbMarketplaceEntity(marketplaceEntityId);

  if (!marketplaceEntity || marketplaceEntity?.status === MarketplaceStatusEnum.Inactive) {
    return null;
  }

  const { cta, monetizable } = marketplaceEntity;

  if (!cta?.link) {
    return null;
  }

  const association = cta?.subtext;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
      <AnalyticsSkuViewed
        impressionPosition={0}
        offerId={marketplaceEntity.id}
        name={marketplaceEntity.name}
        productType={marketplaceEntity.productType}
        monetizable={marketplaceEntity.monetizable}
        level={
          marketplaceEntity?.entityType
            ? EntityTypeEnum[marketplaceEntity.entityType]
            : EntityTypeEnum.offers
        }
        impressionSection={SECTION_NAME}
        source="marketplace"
      >
        <div>
          <CtaComponent
            cta={cta}
            offerId={marketplaceEntity.id}
            monetizable={monetizable}
            text={text}
          />
        </div>
      </AnalyticsSkuViewed>
      {!!association && (
        <Typography
          variant="textSmall"
          sx={{
            color: 'neutral.dark',
          }}
        >
          {association}
        </Typography>
      )}
    </Box>
  );
};
